//LOGIN
export const POST_LOGIN = "/filehandler/auth"
export const POST_SSO_LOGIN = "/filehandler/sso"

//FILES
export const GET_ALL_FILES = "/api/file/all"
export const GET_FILE = "/api/file/"
export const GET_FILE_VIEW = "/api/fileview/"
export const POST_FILE_SEARCH = "/api/file/search"

// ITSOFT
export const GET_ALL_ITSOFT_FILES = "/api/file/itsoft/all"
export const GET_ITSOFT_FILE = "/api/file/itsoft/"

//DOD
export const POST_DOD_FILE_SEARCH = "/api/dod/search"
export const GET_DOD_FILE = "/api/dod/file/"

//CATEGORIES
export const GET_ALL_CATEGORIES = "/api/category/all"

//CLASSEURS
export const GET_ALL_CLASSEURS = "/api/classeur/all"
